module.exports = __webpack_public_path__ + "img/04.f307c88f.png";